/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Toast_ActivatedInputs */

const he_account_notifications_toast_activated = /** @type {(inputs: Account_Notifications_Toast_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראה הופעלה`)
};

const en_account_notifications_toast_activated = /** @type {(inputs: Account_Notifications_Toast_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification activated`)
};

/**
* | output |
* | --- |
* | "Notification activated" |
*
* @param {Account_Notifications_Toast_ActivatedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_toast_activated = /** @type {((inputs?: Account_Notifications_Toast_ActivatedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Toast_ActivatedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_toast_activated(inputs)
	return en_account_notifications_toast_activated(inputs)
});